"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var InputFilled = /** @class */ (function (_super) {
    __extends(InputFilled, _super);
    function InputFilled() {
        var _this = _super.call(this, constants_1.DATA_CONTACT_FORM_SWITCH) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.forms = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_FORM, "]"));
        _this.inputFields = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_INPUT_TEXT, "]"));
        _this.inputCheck = _this.getElement().querySelector("[".concat(constants_1.DATA_INPUT_CHECK, "]"));
        _this.forms.forEach(function (form) {
            // Input Text: Add "filled" class and remove error class
            _this.inputFields.forEach(function (element) {
                if (element.value) {
                    element.classList.add('filled');
                    element.closest('.form__group').classList.add('filled');
                }
                element.addEventListener('change', function () {
                    if (element.value) {
                        element.classList.add('filled');
                        element.closest('.form__group').classList.add('filled');
                        var errorElement = element.closest('.has-error');
                        if (errorElement) {
                            errorElement.closest('.has-error').classList.remove('has-error');
                            if (element.type != 'select-one') {
                                element.nextElementSibling.classList.add('d-none');
                            }
                        }
                    }
                    else {
                        element.classList.remove('filled');
                        element.closest('.form__group').classList.remove('filled');
                    }
                });
            });
            if (_this.inputCheck) {
                // Input Checkbox: Remove error class on change
                _this.inputCheck.addEventListener('change', function () {
                    var errorElement = _this.inputCheck.closest('.has-error');
                    if (errorElement) {
                        errorElement.classList.remove('has-error');
                        _this.inputCheck.closest('.form__check').nextElementSibling.classList.add('d-none');
                    }
                }, { once: true });
            }
        });
        return _this;
    }
    return InputFilled;
}(abstractComponent_1.default));
exports.default = InputFilled;
